/* eslint-disable @typescript-eslint/no-explicit-any */
import { addSubDirectoryPrefix } from '../../../utils/OfferUtils';

const defaultTrackingProperties = {
  enableScrollingBehavior: false,
  trackingDescription: '',
  impressionTrack: false,
  description: '',
  trackingContentPosition: '',
  atCCeVar48: '',
  rightArrowDesc: '',
  cardLocation: '',
  leftArrowDesc: '',
  clickTrack: true,
  location: '',
  merchandisingCategory: 'nonCobrand',
  impressionCount: false,
  trackingTag: '',
  trackingOfferType: '',
};

function distributeEvenlyWithOrderPreserved(items: any[]) {
  const columns: any = [[], [], []];
  const itemsPerColumn = Math.ceil(items?.length / 3);

  items?.forEach((item: any, index) => {
    const columnIndex = Math.floor(index / itemsPerColumn);
    columns[columnIndex].push(item);
  });

  return columns;
}

export const generateCardData = (region: any, cardIndex: any) => {
  const linkListItems = region?.locations
    ?.map((loc: any) => ({
      linkLabel: `${
        loc?.country?.code === 'US' || loc?.country?.code === 'CA'
          ? loc?.stateProvince?.description
          : loc?.country?.description
      } (${loc.propertyCount})`,
      linkURL: addSubDirectoryPrefix(loc?.cta),
      openInNewTab: false,
    }))
    ?.sort((a: { linkLabel: string }, b: { linkLabel: string }) => a.linkLabel.localeCompare(b.linkLabel));

  const groupedRows = distributeEvenlyWithOrderPreserved(linkListItems);
  const cardKey = `card-${cardIndex}`;
  const timestamp = Date.now();

  const variableColumns: any = {};
  groupedRows?.forEach((linkListData: any, colIndex: any) => {
    variableColumns[`variable-column-${colIndex}`] = {
      ':items': {
        linklist: {
          path: '',
          linkListData,
          componentId: `component-${Math.random().toString(36).substring(2, 10)}`,
          ':type': 'mi-aem-common-spa/components/content/linklist',
          impressionTrack: 'false',
          merchandisingCategory: 'nonCobrand',
          impressionCount: 'false',
          alignment: 'vertical-align',
          trackingProperties: {
            ...defaultTrackingProperties,
          },
          wcmMode: 'disabled',
          isAuthor: false,
        },
      },
      allowedComponents: {
        components: [],
        applicable: false,
      },
      ':type': 'mi-aem-common-spa/components/container',
      ':itemsOrder': ['linklist'],
      columnClassNames: {
        linklist: 'aem-GridColumn aem-GridColumn--default--12',
      },
      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
      columnCount: 12,
    };
  });
  const variablecolumncontainer = `variablecolumncontainer-${timestamp}`;
  return {
    [cardKey]: {
      ':items': {
        [variablecolumncontainer]: {
          contentAlignment: 'left',
          desktopColumns: '3',
          componentId: `variable-column-${Math.random().toString(36).substring(2, 10)}`,
          tabletColumns: '3',
          headerTag: 'h2',
          subHeaderTag: 'h2',
          pagePath: '',
          trackingProperties: {
            ...defaultTrackingProperties,
          },
          isAuthor: false,
          ':items': variableColumns,
          path: '',
          ctaType: 'tertiaryLink',
          ':type': 'mi-aem-common-spa/components/content/variablecolumncontainer',
          headerFontSize: 't-title-m',
          subFontSize: 't-subtitle-l',
          ':itemsOrder': ['variable-column-0', 'variable-column-1', 'variable-column-2'],
          itemPath: '',
          descFontSize: 't-font-m',
          reverseStacking: false,
          mobileColumns: '1',
          modelFactory: {},
          openInNewTab: false,
          wcmMode: 'disabled',
        },
      },
      allowedComponents: {
        components: [],
        applicable: false,
      },
      ':type': 'mi-aem-common-spa/components/container',
      ':itemsOrder': [variablecolumncontainer],
      columnClassNames: {
        variablecolumncontainer: 'aem-GridColumn aem-GridColumn--default--12',
      },
      gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
      columnCount: 12,
    },
  };
};

export const getTotalPropertyCount = (region: any): number => {
  return region?.locations?.reduce((total: number, loc: any) => {
    return total + (loc?.propertyCount || 0);
  }, 0);
};
